export function isValidEmbedUrl(url) {
  const supportedVideoLinkSnippet =
    /\S*youtube\.com\/\S*\/*watch\S*|youtu\.be|vimeo.com/
  return url.match(supportedVideoLinkSnippet)
}
